export const ProfileData = [
  {
    'id': 'abstract',
    'intro': 'Más de <em>15 años de experiencia</em> en el área de  comunicación visual.',
    'profiles': [
      {
        'area': 'Dirección Creativa',
        'level': 'Senior'
      },
      {
        'area': 'Product Designer',
        'level': 'Senior'
      },
      {
        'area': 'Frontend',
        'level': 'Semi Senior'
      }
    ]
  },
  {
    'id': 'personal',
    'section': 'Personales',
    'target': '#personal',
    'content': [
      {
        'label': 'Nombre',
        'value': 'Jonathan Zalapa Zalapa'
      },
      {
        'label': 'Edad',
        'value': '39 años'
      },
      {
        'label': 'Sexo',
        'value': 'Másculino'
      },
      {
        'label': 'Residencia',
        'value': 'Morelia, MIC MX'
      },
      {
        'label': 'Móvil',
        'value': '(443) 357 2909'
      },
      {
        'label': 'Correo',
        'value': 'jonminimal@gmail.com'
      }
    ]
  },
  {
    'id': 'formative',
    'section': 'Formación',
    'target': '#formative',
    'content': [
      {
        'degree': 'En proceso de acreditación EGAL',
        'profession': 'Diseño de la Comunicación Gráfica',
        'institute': 'UNLA (Universidad Látina de América)'
      },
      {
        'degree': 'Licenciatura Trunca',
        'profession': 'Mercadotecnia',
        'institute': 'UnADM (Universidad Abierta y a Distancia de México)'
      },
      {
        'degree': 'Licenciatura Trunca',
        'profession': 'Arquitectura',
        'institute': 'UMSNH (Universidad Michoacana de San Nicolás de Hidalgo)'
      },
      {
        'degree': 'Diplomado',
        'profession': 'Mantenimiento de ordenadores',
        'institute': 'ITM (Instituto Tecnológico de Morelia)'
      },
      {
        'degree': 'Diplomado',
        'profession': 'Computación administrativa',
        'institute': 'ECCO'
      }
    ]
  },
  {
    'id': 'experience',
    'section': 'Experiencia',
    'intro': 'Actualmente colaborador en la agencia <em>IA interactive®</em> como especialista en <em>UI/UX.</em>\n' +
      '\n' +
      'Proveedor de servicios profesionales a diversos organismos, entre ellos:',
    'target': '#experience',
    'content': [
      'SE (Secretaría de economía)',
      'SEDENA (Secretaría de la Defensa Nacional)',
      'SEP (Secretaría de Educación Pública)',
      'Gobierno del Estado de Michoacán',
      'UMSNH (Universidad Michoacana de San Nicolás de Hidalgo)',
      'H. Ayuntamiento de Morelia',
      'Grupo Radio S.A.',
      'Pruductos Chata  S.A. de C.V.',
      'Grupo Fame',
      'Grupo Tres Marías',
      'Entre otros…'
    ]
  },
  {
    'id': 'occupational',
    'section': 'Laboral',
    'intro': 'Colaboraciones en diversos organismos y empresas como responsable en diversas áreas visuales.',
    'target': '#occupational',
    'content': [
      {
        'date': '2022-a la fecha',
        'agency': 'Axen Life',
        'rol': 'Product Designer | Service Design',
        'link': {
          'show': true,
          'url': 'https://axenlife.com/'
        }
      },
      {
        'date': '2021-2023',
        'agency': 'Infosel',
        'rol': 'Product Designer',
        'link': {
          'show': true,
          'url': 'https://www.infosel.com/'
        }
      },
      {
        'date': '2019-2021',
        'agency': 'IA interactive®',
        'rol': 'Diseño UI/UX',
        'link': {
          'show': true,
          'url': 'https://www.ia.com.mx/'
        }
      },
      {
        'date': '2020-a la fecha',
        'agency': 'Softwareland',
        'rol': 'Proveedor externo Product Designer & Frontend',
        'link': {
          'show': true,
          'url': 'http://softwareland.mx/'
        }
      },
      {
        'date': '2020-a la fecha',
        'agency': 'dgk',
        'rol': 'Proveedor externo Product Designer & Frontend',
        'link': {
          'show': true,
          'url': 'https://dgk.com.mx/'
        }
      },
      {
        'date': '2016-2019',
        'agency': 'Minimista Estudio',
        'rol': 'Dirección Creativa',
        'link': {
          'show': false,
          'url': ''
        }
      },
      {
        'date': '2013-2016',
        'agency': 'Grupo Tres Marías',
        'rol': 'Proveedor externo Diseño Publicitario',
        'link': {
          'show': true,
          'url': 'https://www.tresmarias.com.mx/'
        }
      },
      {
        'date': '2012-2014',
        'agency': 'Editorial Alterna S.A. de C.V.',
        'rol': 'Dirección de Arte',
        'link': {
          'show': false,
          'url': ''
        }
      },
      {
        'date': '2012-2013',
        'agency': 'Casa Palta',
        'rol': 'Coordinación de Diseño',
        'link': {
          'show': false,
          'url': ''
        }
      },
      {
        'date': '2007-2008',
        'agency': 'Diario Provincia',
        'rol': 'Edición Gráfica',
        'link': {
          'show': false,
          'url': ''
        }
      }
    ]
  },
  {
    'id': 'projects',
    'section': 'Proyectos',
    'intro': 'Ejecución y participación en diversos proyectos de diferentes áreas y giros, entre los últimos destacan:',
    'target': '#projects',
    'content': [
      {
        'agency': 'IA interactive®',
        'project': 'Dinny®',
        'type': 'App',
        'intro': 'Aplicación delivery (iOS & Android) orientada al consumo de alimentos.',
        'activity': [
          'Diseño de interfaz de usuario de aplicación móvil.',
          'Diseño de interfaz de usuario de CMS.',
          'Diseño de interfaz de usuario de Mesa de Órdenes.',
          'Prototipado en general.',
          'Pruebas de usabilidad'
        ]
      },
      {
        'agency': 'IA interactive®',
        'project': 'Sartorum',
        'type': 'e-commerce',
        'intro': 'Broker de seguros en línea.',
        'activity': [
          'Diseño de interfaz de usuario',
          'Prototipado en general'
        ]
      },
      {
        'agency': 'IA interactive®',
        'project': 'Tecate',
        'type': 'App',
        'intro': 'Aplicación móvil orientada para brinndar beneficios a consumidores de la marca.',
        'activity': [
          'Diseño de interfaz de usuario',
          'Prototipado en general'
        ]
      },
      {
        'agency': 'Softwareland',
        'project': 'BQuate',
        'type': 'CMS, WEB',
        'intro': 'Conjunto de plataformas para la administración y publicación de contenidos musicales.',
        'activity': [
          'Diseño de interfaz de usuario',
          'Frontend'
        ]
      },
      {
        'agency': 'Chata',
        'project': 'Chata: Rutas',
        'type': 'App',
        'intro': 'Aplicación móvil interna de la empresa para la gestión de rutas.',
        'activity': [
          'Product Design',
          'Diseño de interfaz de usuario',
          'Prototipado en general'
        ]
      },
      {
        'agency': 'Chata',
        'project': 'Chata: CMS',
        'type': 'CMS',
        'intro': 'Plataforma para administrar contenidos de aplicación de rutas.',
        'activity': [
          'Diseño de interfaz de usuario',
          'Frontend'
        ]
      }
    ]
  },
  {
    'id': 'training',
    'section': 'Capacitación',
    'intro': 'Entrenamiento en el desarrollo de conocimientos, habilidades y competencias en diferentes materias.',
    'target': '#training',
    'content': [
      'UX testing y prototipado para dispositivos móviles',
      'React: De cero a experto ( Hooks y MERN )',
      'Angular: De cero a experto - ( Edición 2021 )',
      'Desarrollo de un manual de identidad corporativa',
      'Planeación de campañas publicitarias',
      'Liderazgo creativo',
      'Formación y actualización tecnológica',
      'Genera un plan de marketing',
      'Team Back, lineamiento para el alto desempeño'
    ]
  },
  {
    'id': 'certificate',
    'section': 'Certificaciones',
    'intro': 'Acreditación y validación en competencias especificas para garantizar un desempeño profesional.',
    'target': '#certificate',
    'content': [
      {
        'course': 'Foundations of User Experience (UX) Design',
        'platform': 'Google Career Certificates'
      },
      {
        'course': 'Business Design para UX',
        'platform': 'Crehana'
      },
      {
        'course': 'Creatividad para grandes marcas',
        'platform': 'Domestika'
      },
      {
        'course': 'Creación de una style guide para apps',
        'platform': 'Domestika'
      }
    ]
  },
  {
    'id': 'methodology',
    'section': 'Metodologías',
    'intro': 'Experiencia en marcos y técnicas adquiridas para brindar organización, ágilidad y mejora en el proceso del desarollo de tales tecnologías.',
    'target': '#methodology',
    'content': [
      'Scrum',
      'Agil',
      'Design Sprint',
      'Design Sprint 2.0',
      'Design Thinking',
      'Human Centered Design'
    ]
  },
  {
    'id': 'skills',
    'section': 'Competencias',
    'intro': 'Conocimientos, destrezas y capacidades adquiridas para un desempeño cualificado, que permita la obtención de resultados óptimos.',
    'target': '#skills',
    'content': [
      {
        'area': 'Dirección Creativa',
        'displaySub': false,
        'subcontent': [
          {
            'subhead': 'Proceso Creativo',
            'aptitudes': []
          },
          {
            'subhead': 'Directrices de Diseño',
            'aptitudes': []
          }
        ]
      },
      {
        'area': 'Diseño Aplicado',
        'displaySub': false,
        'subcontent': [
          {
            'subhead': 'Editorial',
            'aptitudes': []
          },
          {
            'subhead': 'Branding',
            'aptitudes': []
          },
          {
            'subhead': 'Edición',
            'aptitudes': []
          },
          {
            'subhead': 'Empaque',
            'aptitudes': []
          }
        ]
      },
      {
        'area': 'UI/UX',
        'displaySub': false,
        'subcontent': [
          {
            'subhead': 'UX Research',
            'aptitudes': []
          },
          {
            'subhead': 'Wireframing',
            'aptitudes': []
          },
          {
            'subhead': 'Diseño de interfaz',
            'aptitudes': []
          },
          {
            'subhead': 'Prototipado',
            'aptitudes': []
          },
          {
            'subhead': 'Pruebas de usabilidad',
            'aptitudes': []
          }
        ]
      },
      {
        'area': 'Frontend',
        'displaySub': true,
        'subcontent': [
          {
            'subhead': 'Lenguajes',
            'aptitudes': [
              'HTML',
              'CSS',
              'JS'
            ]
          },
          {
            'subhead': 'Preprocesadores',
            'aptitudes': [
              'Pug',
              'Sass'
            ]
          },
          {
            'subhead': 'Frameworks',
            'aptitudes': [
              'Angular'
            ]
          },
          {
            'subhead': 'Librerías',
            'aptitudes': [
              'React',
              'Styled Components',
              'Tailwind CSS',
              'Bootstrap'
            ]
          }
        ]
      }
    ]
  },
  {
    'id': 'tools',
    'section': 'Herramientas',
    'intro': 'Conocimientos aplicados, experiencia y actualización como una constante en instrumentos y medios útiles, que favorecen la ejecución de acciones en la esfera digital.',
    'target': '#tools',
    'content': [
      {
        'area': 'Diseño Aplicado',
        'displaySub': true,
        'subcontent': [
          {
            'subhead': 'Adobe',
            'apps': [
              'Illustrator',
              'Photoshop',
              'Indesign'
            ]
          }
        ]
      },
      {
        'area': 'UI/UX',
        'displaySub': true,
        'subcontent': [
          {
            'subhead': 'Interfaz',
            'apps': [
              'Figma',
              'Sketch',
              'Adobe XD'
            ]
          },
          {
            'subhead': 'Prototipado',
            'apps': [
              'Marvel',
              'Invision',
              'Principle'
            ]
          },
          {
            'subhead': 'Handoff',
            'apps': [
              'Zeplin',
              'Avocode',
              'InVision'
            ]
          },
          {
            'subhead': 'Versionamiento',
            'apps': [
              'Abstract'
            ]
          }
        ]
      },
      {
        'area': 'Frontend',
        'displaySub': true,
        'subcontent': [
          {
            'subhead': 'IDE',
            'apps': [
              'WebStorm',
              'Visual Studio Code',
              'Sublime Text'
            ]
          },
          {
            'subhead': 'Git GUI',
            'apps': [
              'Sourcetree',
              'WebStorm'
            ]
          }
        ]
      },
      {
        'area': 'Colaborativo',
        'displaySub': true,
        'subcontent': [
          {
            'subhead': 'Planning & Sprint',
            'apps': [
              'Miro',
              'Jira',
              'Trello',
              'ClickUp',
              'Airtable',
            ]
          },
          {
            'subhead': 'Recursos & Documentación',
            'apps': [
              'Sharepoint',
              'Google Drive',
              'Dropbox',
              'Confluence',
              'MS Office'
            ]
          },
          {
            'subhead': 'Git',
            'apps': [
              'GitLab',
              'GitHub',
              'Bitbucket'
            ]
          },
          {
            'subhead': 'Comunicación',
            'apps': [
              'MS Teams',
              'Google Meet',
              'Slack'
            ]
          }
        ]
      }
    ]
  },
  {
    'id': 'language',
    'section': 'Idiomas',
    'intro': 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat.',
    'target': '#language',
    'content': [
      {
        'language': 'Español',
        'level': 'Lengua nativa'
      },
      {
        'language': 'Inglés',
        'level': 'Nivel Básico'
      }
    ]
  }
];

export default ProfileData;
